import { Grid, Tooltip} from "@mui/material";

export function getCampaignStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        audienceid:{
            name:'audienceid',
            label:'Audience Id',
            value:'',
            error:false,
            errorMessage:'You must enter Audience Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        audiencename:{
            name:'audiencename',
            label:'Audience Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        audienceemail:{
            name:'audienceemail',
            label:'Audience Email',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'emailid'
        },
        templateid:{
            name:'templateid',
            label:'Template  Id',
            value:'',
            error:false,
            errorMessage:'You must enter Template  Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        templatename:{
            name:'templatename',
            label:'Template  Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'audiencename', headerName: 'Audience Name', width:150 },
        { field: 'audienceemail', headerName: 'Audience Email', width:150 },
        { field: 'templatename', headerName: 'Template  Name', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['audienceid']:{
          ...formValues['audienceid'],
          value:data.audienceid,
        },['audiencename']:{
          ...formValues['audiencename'],
          value:data.audiencename,
        },['audienceemail']:{
          ...formValues['audienceemail'],
          value:data.audienceemail,
        },['templateid']:{
          ...formValues['templateid'],
          value:data.templateid,
        },['templatename']:{
          ...formValues['templatename'],
          value:data.templatename,
        },
      })
}